<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
           
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
                <p>
                يجب أن يكون ملف المحضر المُرفق في هذه المعاملة وفق النموذج التالي , بعد توقيعه من الأعضاء
              </p>
              <a
                class="mx-1 d-flex justify-content-end"
                href="/docs/Board_of_Directors_or_Trustees_Meeting_Minutes_Record_Form.docx"
                download
              >
                <b-button size="sm" variant="info">
                  <feather-icon icon="DownloadIcon" class="mr-50" />
                  تحميل
                </b-button>
              </a>
              <hr />
              
            </b-col>
            <b-col cols="12">
              <form-input
                label="رقم محضر الاجتماع"
                v-model="form.title"
                rules="required"
              />

            </b-col>
            
            <b-col cols="12">
              <form-mask
                label="تاريخ محضر الاجتماع"
                id="meeting_date"
                v-model="form.meeting_date"
                :raw="false"
                placeholder="YYYY-MM-DD"
                options="date"
                rules="required"
              />
              <small class="text-danger" v-if="isDataAfter">يجب أن يكون تاريخ الاجتماع قبل التاريخ الحالي</small>
              
            </b-col>

            
              
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع الاجتماع"
                id="meeting-type"
                v-model="form.meeting_type_id"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/meeting-types"
                
              />
            </b-col>
            <b-col cols="12">

              <b-form-group label="اسماء الحضور" label-for="details">
                <validation-provider
                  #default="{ errors }"
                  name="اسماء الحضور"
                  rules="required"
                  id="details"
                  mode="passive"
                >
                  <quill-editor
                    :options="editorOption"
                    v-model="form.attendance_names"
                    :class="{ quillEditor: errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
           
            <b-col>
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                label="ملف المحضر"
                accept="application/pdf"
                v-model="form.file"
                rules="required"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
  import IdCard from "../IdCard/index.vue";
import { ifSpecifiedPeriodHasExceeded } from "@/utils/utils";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    IdCard
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      isDataAfter : false,
      govId: null,
      mapModal: false,
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          if(!ifSpecifiedPeriodHasExceeded(this.form.meeting_date)){
            
            this.isDataAfter = true
          }
          else{
            this.isDataAfter = false
          }
          if(this.isDataAfter === false){
            this.$emit("confirm", this.form);
          }
        }
      });
    },
    
    specifiedPeriodHasExceeded(endData){
      return ifSpecifiedPeriodHasExceeded(endData)
    }
  },
};
</script>
